export const PUBLIC_URL = process.env.PUBLIC_URL || '';
export const DASHLITE_ASSET = (path) => `${PUBLIC_URL}/dashlite/${path}`;

let styleLoaded = false;

export function ensureDashliteStyles() {
  if (styleLoaded) return;
  ['assets/css/dashlite.css', 'assets/css/theme.css'].forEach((href) => {
    const id = `dashlite-${href.replace(/\//g, '-')}`;
    if (document.getElementById(id)) return;
    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = DASHLITE_ASSET(href);
    document.head.appendChild(link);
  });
  styleLoaded = true;
}

export const DASHLITE_BODY_CLASS = 'nk-body ui-rounder has-sidebar ui-light';

export function setDashliteBodyClass(className = DASHLITE_BODY_CLASS) {
  document.body.className = className;
}
